/**
 * SettingsProvider - wraps the app to provide org settings context.
 * Fetches settings once on mount (when authenticated).
 */
import React, { useEffect } from 'react';
import { SettingsContext, useSettingsProvider } from '@/hooks/useSettings';
import { useAuth } from '@/contexts/AuthContext';

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { settings, isLoading, error, updateSettings, refreshSettings, fetchOnMount } =
    useSettingsProvider();

  useEffect(() => {
    if (isAuthenticated) {
      fetchOnMount();
    }
  }, [isAuthenticated, fetchOnMount]);

  return (
    <SettingsContext.Provider value={{ settings, isLoading, error, updateSettings, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};
